(() => {
  const cardSelector = [
    '.rebuy-cart__flyout-recommendations .rebuy-product-block',
    '.rebuy-cart__upsells .rebuy-product-block'
  ].join(',');
  const productCache = new Map();

  async function getProduct(card) {
    const link = card.querySelector('.rebuy-product-title-link[href], .rebuy-product-image[href]');

    if (!link) return null;

    const productUrl = new URL(link.href, window.location.origin);
    const productPath = productUrl.pathname.replace(/\/$/, '');

    if (!productPath.includes('/products/')) return null;

    if (!productCache.has(productPath)) {
      productCache.set(
        productPath,
        fetch(`${productPath}.js`).then((response) => {
          if (!response.ok) throw new Error(`Unable to load ${productPath}`);
          return response.json();
        })
      );
    }

    return productCache.get(productPath);
  }

  function addItem(variantId, button) {
    if (!window.Rebuy?.Cart?.addItem) return;

    const originalText = button.textContent;
    const resetButton = () => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
    };

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';

    try {
      const result = window.Rebuy.Cart.addItem(
        { id: Number(variantId), quantity: 1 },
        {
          success: () => {
            button.textContent = 'Added';
            window.setTimeout(resetButton, 1200);
          },
          error: resetButton
        }
      );

      if (result?.catch) result.catch(resetButton);
    } catch (error) {
      resetButton();
    }
  }

  async function enhanceCard(card) {
    if (card.dataset.gatInlineOptions === 'loading' || card.dataset.gatInlineOptions === 'ready') return;
    if (card.querySelector('.rebuy-product-options')) return;

    card.dataset.gatInlineOptions = 'loading';

    try {
      const product = await getProduct(card);

      if (!product || product.requires_selling_plan || !product.variants?.length) {
        delete card.dataset.gatInlineOptions;
        return;
      }

      const availableVariants = product.variants.filter((variant) => variant.available);

      if (!availableVariants.length) {
        delete card.dataset.gatInlineOptions;
        return;
      }

      const panel = document.createElement('div');
      panel.className = 'gat-rebuy-options';

      const label = document.createElement('label');
      label.className = 'gat-rebuy-options__label';
      label.textContent = product.variants.length > 1 ? 'Select option' : 'Ready to add';

      const controls = document.createElement('div');
      controls.className = 'gat-rebuy-options__controls';

      const select = document.createElement('select');
      select.className = 'gat-rebuy-options__select';
      select.setAttribute('aria-label', `Choose an option for ${product.title}`);

      availableVariants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.public_title || variant.title;
        select.append(option);
      });

      const addButton = document.createElement('button');
      addButton.className = 'gat-rebuy-options__button';
      addButton.type = 'button';
      addButton.textContent = 'Add';
      addButton.addEventListener('click', () => addItem(select.value, addButton));

      if (product.variants.length > 1) controls.append(select);
      controls.append(addButton);
      panel.append(label, controls);

      const actions = card.querySelector('.rebuy-product-actions');
      if (actions) {
        actions.before(panel);
      } else {
        card.append(panel);
      }

      if (actions) actions.classList.add('gat-rebuy-original-actions');
      card.dataset.gatInlineOptions = 'ready';
    } catch (error) {
      delete card.dataset.gatInlineOptions;
    }
  }

  function enhanceRecommendations(root = document) {
    root.querySelectorAll(cardSelector).forEach(enhanceCard);
  }

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) enhanceRecommendations();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('rebuy:smartcart.show', () => enhanceRecommendations());
  document.addEventListener('rebuy:widget.ready', () => enhanceRecommendations());
  enhanceRecommendations();
})();
